import { useTranslation } from "react-i18next";

const TONE = {
  active: "bg-emerald-500",
  terminated: "bg-rose-500",
  rejected: "bg-rose-500",
  resigned: "bg-rose-500",
  dismissed: "bg-rose-500",
  suspended: "bg-sky-500",
  pending: "bg-sky-500",
  onboarding: "bg-sky-500",
};

export const StatusBadge = ({ status, className = "" }) => {
  const { t } = useTranslation();
  if (!status) return null;
  const tone = TONE[status] || "bg-muted-foreground";
  return (
    <span data-testid="detail-status-badge" className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold text-white shadow-neu-sm ${tone} ${className}`}>
      {t(`detail.statusValues.${status}`)}
    </span>
  );
};
